import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class RejectModal extends Component {
    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    {/* <div className="model-header">
                        <img src="/images/rejectModal.png" alt=""></img>
                    </div> */}
                    <h2 className="model-title text-center" id="model-title">
                        Reject Applicant
                    </h2>
                    <div className="model-content">
                        <div
                            id="model-content"
                            onClick={this.props.toggleApproveModal}
                            className=" text-center model-html-container"
                        >
                            Are you sure you want to reject this applicant?
                        </div>
                        <div
                            className="model-validation-message"
                            id="model-validation-message"
                        ></div>
                    </div>
                    <div className="model-actions">
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={this.props.rejectApplicant}
                        >
                            Reject
                        </button>
                        <button
                            type="button"
                            onClick={this.props.toggleRejectModal}
                            className="btn btn-default"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
RejectModal.contextType = AppContext;
export default RejectModal;



// WEBPACK FOOTER //
// ./src/components/employer/jobListing/RejectModal.js